<script setup lang="ts">
import { ref } from 'vue'
import { FilterField, TableField } from "../../../../components/table/table";
import { Permission } from '../../../../types/auth'
import ListTemplate from "../../../../components/ui/common/ListTemplate.vue";
import CashierDutysForm from './CashierDutysForm.vue';

withDefaults(defineProps<{
  showHeader?: boolean,
  showQuickTour?: boolean,
  showTitle?: boolean,
  showNextButton?: boolean
  permissions?: Permission[]
}>(), {
  showHeader: true,
  showQuickTour: true,
  showTitle: true
})

const endPoint = "/clients/system/security/cashier-dutys/";
const title = "Cashier Dutys";
const selectedData = ref<any | null>(null);
const showForm = ref(false);
const formMode = ref<
  "create" | "edit" | "view" | "showQuickView" | "toggleStatus"
>("view");
const refreshData = ref(false);

const fields: TableField[] = [
  {
    name: "profile_photo",
    caption: "Photo",
    sortable: true,
    fieldType: "image",
  },
  { name: "date_time", caption: "Date", sortable: true, fieldType: "text" },
  { name: "user", caption: "User", sortable: true, fieldType: "text" },
  {
    name: "started_time",
    caption: "Started at",
    sortable: true,
    fieldType: "datetime",
  },
  {
    name: "ended_time",
    caption: "Finished On",
    sortable: true,
    fieldType: "datetime",
  },
  { name: "outlet", caption: "Outlet", sortable: true, fieldType: "text" },
  {
    name: "pos_station",
    caption: "POS Station",
    sortable: true,
    fieldType: "text",
  },
  {
    name: "cancelled",
    caption: "active",
    sortable: false,
    fieldType: "status",
  },
];

const filterFields: FilterField[] = [
  {
    name: 'active',
    label: 'Status',
    type: 'select',
    value: '',
     options: [
      { id: "1", name: "Active" },
      { id: "0", name: "Inactive" },
    ],
  },
]

const changeMode = (
  mode: "create" | "edit" | "view" | "showQuickView" | "toggleStatus"
) => {
  formMode.value = mode;
  showForm.value = mode === "view" || mode === "edit" || mode === "create";
};

const handleData = (data : any) => {
  selectedData.value = data
}
</script>

<template>
  <ListTemplate :endPoint = "endPoint" :title = "title" :fields = "fields" :actions = "[]" :filterFields ="filterFields"
  :tabList = "[]" :refreshData = "refreshData" @mode="changeMode" @show="showForm = true" :showForm="showForm" 
  @data="handleData" :show-header="showHeader" :show-quick-tour="showQuickTour" :show-title="showTitle">
  <template #form-view>
    <CashierDutysForm
      :permissions="permissions"
      v-if="showForm"
      :data="selectedData"
      :end-point="endPoint"
      :title="title"
      :mode="formMode"
      @save="refreshData = !refreshData"
      @close="showForm = !showForm"
    />
  </template>
  </ListTemplate>
</template>